import { useQuery } from "react-query";
import { getHeaderAuthBearerToken } from "utils/requests/auth";
import { webApi } from "services/api/config";

export function useQueryGetUserRuleset(userId) {
  return useQuery(["useQueryGetUserRuleset", userId], async () => {
    const { data } = await webApi.get(`api/userRuleset/${userId}`, {
      headers: {
        Authorization: getHeaderAuthBearerToken(),
      },
    });
    return data;
  });
}
